import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import styles from './styles.scss';
import { getEmailContacts } from '../../../actions/profile/apiRequests';


class TagsInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
  }

  static get propTypes() {
    return {
      maxTagsNumber: PropTypes.number,
      placeholder: PropTypes.string,
      value: PropTypes.array,
      validator: PropTypes.func,
      onChange: PropTypes.func
    }
  }

  static get defaultProps() {
    return {
      maxTagsNumber: 5
    }
  }
  
  onChange (tags) {
    const {
      validator,
      onChange
    } = this.props;

    if (validator) {
      tags = tags
        .map(tag => (validator(tag.value) ? tag : null))
        .filter(tag => !!tag);
    }

    if (onChange) {
      onChange(tags);
    }
  }

  loadOptions(value) {
    return getEmailContacts(value).then((emails) => {
      const options = emails.length !== 0 ? this.deserializeEmails(emails) : emails
      return { options }
    });
  }

  deserializeEmails(emails) {
    return emails.map((email) => {
      return {
        value: email,
        label: email,
      };
    });
  }

  render() {
    const {
      value:tags,
      maxTagsNumber,
      placeholder
    } = this.props;

    return (
      <Select.AsyncCreatable className={styles.inputField}
        placeholder={placeholder}
        multi={true}
        arrowRenderer={null}
        searchable={tags.length < maxTagsNumber}
        noResultsText=''
        onChange={this.onChange}
        loadOptions={this.loadOptions}
        value={tags}
        openOnClick={false}
        openOnFocus={false}
        promptTextCreator={(label) => `Add email "${label}"`}
      />
    );
  }
}

export default TagsInput;


// WEBPACK FOOTER //
// src/components/shared/TagsInput/index.jsx